/* eslint-disable @typescript-eslint/naming-convention */
export interface ILimitedEmployeeInfoAndContact {
  EmployeeID: string;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Phone: string;
  CellPhone: string;
  AlternatePhone: string;
  Email: string;
  Position: string;
}
